const DynamicPhishingDecision = (props) => {
  const decision = props?.row?.original?._source?.decision || props?.row?.original?.decision;
  return (
    <div
      className={`dynamic-phishing-emails__table__decision dynamic-phishing-emails__table__decision--${
        decision === "allowed"
          ? "allowed"
          : decision === "pending"
            ? "pending"
            : decision === "notallowed"
              ? "not-allowed"
              : "not-decided"
      } `}>
      {decision === "allowed"
        ? "allowed"
        : decision === "pending"
          ? "pending"
          : decision === "notallowed"
            ? "not allowed"
            : "not decided"}
    </div>
  );
};

export default DynamicPhishingDecision;
